import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem } from "./Components";
import cov_bys from "../img/sswpIcons/Covid/cov_bys.png"
import cov_1st_aid from "../img/sswpIcons/Covid/cov_1st_aid.png";
import cov_can_arr from "../img/sswpIcons/Covid/cov_can_arr.png";
import cov_cov_ppe from "../img/sswpIcons/Covid/cov_cov_ppe.png";
import cov_del from "../img/sswpIcons/Covid/cov_del.png";
import cov_eat_on_sit from "../img/sswpIcons/Covid/cov_eat_on_sit.png";
import cov_haz from "../img/sswpIcons/Covid/cov_haz.png";
import cov_mee from "../img/sswpIcons/Covid/cov_mee.png";
import cov_per_hyg from "../img/sswpIcons/Covid/cov_per_hyg.png";
import cov_phy_dis from "../img/sswpIcons/Covid/cov_phy_dis.png";
import cov_sig from "../img/sswpIcons/Covid/cov_sig.png";
import cov_too_equ_sur from "../img/sswpIcons/Covid/cov_too_equ_sur.png";
import cov_veh from "../img/sswpIcons/Covid/cov_veh.png";
import cov_wel_arr from "../img/sswpIcons/Covid/cov_wel_arr.png";
import cov_wor_org from "../img/sswpIcons/Covid/cov_wor_org.png";
const json = {
    icon: cov_haz,
    name: "Covid-19",
    text: "",
    icons: {
        cov_bys: {
            name: "Before You Start",
            icon: cov_bys,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            Before You Start
                        </Typography>
                    </Li>
                </ul>
            ),
        },
        cov_wor_org: {
            name: "Work Organisation",
            icon: cov_wor_org,
            text: (
                <ul>
                    <ListItem text="Disperse Activities - Keep work groups as small as possible. Organise staff and plant such that they are dispersed throughout the site, when it is safe to do so." />
                    <ListItem text="Work Method - Operate side by side or facing away from each other where possible" />
                    <ListItem text="Organise teams - Organise staff into teams/ crews who consistently work and take breaks together. Keep teams as small as is reasonably practical and safe." />
                    <ListItem text="Organise breaks - Organise breaks to facilitate the maintenance of physical distancing. " />
                    <ListItem text="Organise staff spaces - Organise working areas to ensure tables and chairs are far enough apart." />
                    <ListItem text="Organise Routes - Provide one-way systems for access/egress by staff (by vehicle, or on foot)" />
                    <ListItem text="Minimise public encounters - Minimise encounters with members of the public by barriers/ providing alternative public arrangements" />
                    <ListItem text="Use Stairs - Encourage use of stairs and avoid lifts." />
                </ul>
            ),
        },
        cov_phy_dis: {
            name: "Physical Distancing",
            icon: cov_phy_dis,
            text: (
                <ul>
                    <ListItem text="2 metre space - Keep 2 metres of space beween you and other people" />
                    <ListItem text="No hand shaking - Do not shake hands" />
                    <ListItem text="Temporary Barriers - Install temporary physical barriers, such as clear plastic guards between employees/ people." />
                    <ListItem text="Maximize distance - Try and maintain a minimum of 1m distance if reasonably practicable" />
                    <ListItem text="<15 minutes - Avoid spending more than 15 minutes within 2 meters of another person. In all cases limit the amount of time of close working to the absolute minimum." />
                    <ListItem text="Exclusion Zone - Only those required for the activity shall be allowed within the exclusion zone." />
                    <ListItem text="Ventilation - Insure work space is well ventilated with fresh (not re-circulated) air" />
                </ul>
            ),
        },
        cov_per_hyg: {
            name: "Personal Hygiene",
            icon: cov_per_hyg,
            text: (
                <ul>
                    <ListItem text="Wash/ Sanitise Hands - Wash hands each and every time before you begin work and after you finish work, even for breaks." />
                    <ListItem text="Cough Etiquette - Cover your mouth AND nose with a tissue or your sleeve when you cough and sneeze." />
                    <ListItem text="Used Tissue - Put used tissues into a bin and wash your hands." />
                    <ListItem text="Soap and Water - Use soap and water to wash hands. Wash thoroughly for 20 seconds. You should only use disposable towels/ air dryers to dry hands" />
                    <ListItem text="Hand Sanitiser - Hand sanitiser should contain at leat 60% alcohol. Use generours amounts of hand sanitiser to wash hands. Wash thoroughly for 20 seconds. You should only use disposable towels/ air dryers to dry hands" />
                    <ListItem text="Hand Wipes - Sufficient amounts must be provided for all employees on site." />
                    <ListItem text="Locating at entrances - Hand washing points must be available at main entry points and locations throughout site." />
                    <ListItem text="Don't Touch Face - Do NOT touch your face, in particular eyes, nose or mouth. Clean your hands often and thoroughly." />
                </ul>
            ),
        },
        cov_wel_arr: {
            name: "Welfare Arrangements",
            icon: cov_wel_arr,
            text: (
                <ul>
                    <ListItem text="Cleaning Materials - " />
                    <Li>
                        <Typography variant="title">
                            Enhanced Cleaning - Implement an enhanced cleaning
                            regime paying particular attention to high touch
                            surfaces
                        </Typography>
                        <ol>
                            <ListItem text="Taps and washing facilities" />
                            <ListItem text="Toilet flush and seats" />
                        </ol>
                    </Li>
                    <ListItem text="Staggered Shift Times - Introduce staggered start and finish times to reduce congestion and contact incidents." />
                    <ListItem text="Capacity - Assess capacity of facilities to ensure 2m distancing rule." />
                    <ListItem text="Waste Collection points - Increase the number of waste collection points" />
                    <ListItem text="Queue Management - Implement a queue management system with correct distance markings and singage" />
                    <ListItem text="Wash/ Sanitise Hands - Wash hands before and after using toilet facilities" />
                </ul>
            ),
        },
        cov_can_arr: {
            name: "Canteen Arrangements",
            icon: cov_can_arr,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            Cleaning Materials
                        </Typography>
                        <Typography variant="body1">
                            Adequate cleaning material stock must be maintained
                            throughout the day.
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">Staff numbers</Typography>
                        <Typography variant="body1">
                            Ensure there is sufficient space (> 2m) between
                            staff on breaks
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">Seating</Typography>
                        <Typography variant="body1">
                            Ensure seating arrangement >2m apart
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">Stagger</Typography>
                        <Typography variant="body1">
                            Stagger break times to reduce congestion and contact
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Wash/ Sanitise Hands
                        </Typography>
                        <Typography variant="body1">
                            Wash hands before and after eating.
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Queue Management
                        </Typography>
                        <Typography variant="body1">
                            Implement a queue management system with correct
                            distance markings and signage
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">Clean</Typography>
                        <Typography variant="body1">
                            Tables must be cleared when finished eating and
                            cleaed before each use.
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">Don't Share</Typography>
                        <Typography variant="body1">
                            Do NOT share objects that touch your mouth. E.g.
                            bottles, cups, cutlery etc.
                        </Typography>
                    </Li>
                </ul>
            ),
        },
        cov_eat_on_sit: {
            name: "Eating on Site",
            icon: cov_eat_on_sit,
            text: (
                <ul>
                    <ListItem text="You are encouraged to take your break in your vehicle on your own." />
                </ul>
            ),
        },
        cov_too_equ_sur: {
            name: "Tools, Equipment, Surfaces",
            icon: cov_too_equ_sur,
            text: (
                <ul>
                    <ListItem text="Allocated Tools - Avoid the sharing of tools and equipment as much as possible." />
                    <ListItem text="Clean Tools - All shared tools to be sanitised BEFORE AND AFTER use." />

                    <Li>
                        <Typography variant="title">
                            Enhanced Cleaning - Implement an enhanced cleaning
                            regime paying particular attention to high touch
                            surfaces
                        </Typography>
                        <ol>
                            <ListItem text="handrails on staircases and corridors" />
                            <ListItem text="Door handles, lift buttons" />
                        </ol>
                    </Li>
                    <ListItem text="Cleaning Materials - Adequate cleaning material stock must be maintained throughout the day." />
                    <ListItem text="Cleaning frequency - Clean at least twice per day or when visibly dirty" />
                    <ListItem text="Waste Collection points - Increase the number of waste collection points" />
                    <ListItem text="Minimise paperwork - Minimise handling of paper documents/ cash where possible" />
                </ul>
            ),
        },
        cov_veh: {
            name: "Vehicles",
            icon: cov_veh,
            text: (
                <ul>
                    <ListItem text="Parking - " />
                    <ListItem text="Single occupancy - " />
                    <ListItem text="Ventilation - " />
                    <Li>
                        <Typography variant="title">
                            Enhanced Cleaning - Implement an enhanced cleaning
                            regime paying particular attention to high touch
                            surfaces
                        </Typography>
                        <ol>
                            <ListItem text="door handles" />
                            <ListItem text="steering wheel" />
                            <ListItem text="handbrake" />
                            <ListItem text="gear stick" />
                            <ListItem text="radio and other controls" />
                            <ListItem text="Elbow rests" />
                            <ListItem text="Seat Positions" />
                            <ListItem text="Door frame" />
                        </ol>
                    </Li>
                    <ListItem text="Hand Sanitiser - Hand sanitiser should be provided for the vehicle. Use generours amounts of hand sanitiser to wash hands. You should only use disposable towels/ air dryers to dry hands" />
                </ul>
            ),
        },
        cov_sig: {
            name: "Signage",
            icon: cov_sig,
            text: (
                <ul>
                    <ListItem text="COVID-19 Signage - Ensure COVID-19 signage and advice measures are in visible locations" />
                    <ListItem text="Hand Washing Signage - Ensure clear pictogram based signage at wash points/ sanitising points." />
                    <ListItem text="Queue Signage - Use queue management with floor markings and COVID-19 signage" />
                    <ListItem text="Disinfection Signage - Use disinfection signage within vehicles and in tool/equipment stores." />
                    <ListItem text="Walkway markings - Walkways may be marked up to indicate one-way systems, direction to follow, 2m distancing" />
                </ul>
            ),
        },
        cov_del: {
            name: "Deliveries",
            icon: cov_del,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            Delivery Dockets
                        </Typography>
                        <Typography variant="body1">
                            Do not touch/ sign delivery dockets. Take pictures
                            or ask for electronic copies.
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">Plan Deliveries</Typography>
                        <Typography variant="body1">
                            Plan all deliveries with allocated times
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="body1">
                            Comply with the controls identified for Physical
                            Distancing. The driver should NOT exit the vehicle
                            where possible.
                        </Typography>
                    </Li>
                </ul>
            ),
        },
        cov_mee: {
            name: "Meetings",
            icon: cov_mee,
            text: (
                <ul>
                    <ListItem text="Remote meetings - Use online video conference tools, conference calls, phone calls, messenger services." />
                    <ListItem text="Reduce meeting time - Keep meetings as short as possible." />
                    <ListItem text="Reduce meeting attendance - Keep attendance to the absolute minimum required." />
                </ul>
            ),
        },
        cov_1st_aid: {
            name: "First Aid",
            icon: cov_1st_aid,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            First Aider Induction
                        </Typography>
                        <Typography variant="body1">
                            First Aid Responders must be provided with a
                            briefing on infection prevention and control
                            principles including hand hygiene and appropriate
                            use of personal protective equipment and equipment
                            when delivering first aid.
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Disposable Gloves (nitrile/latex)
                        </Typography>
                        <Typography variant="body1">
                            Should have disposable gloves (nitrile/latex) within
                            first aid kit.
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            FFP3/ FFP2 Face Mask
                        </Typography>
                        <Typography variant="body1">
                            Should have a face mask rated FFP2 or FFP3 within
                            first aid kit. Must be replaced after each use.
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Disposable Plastic Apron
                        </Typography>
                        <Typography variant="body1">
                            Should have disposable plastic apron within first
                            aid kit.
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Enclosed Eye Protection
                        </Typography>
                        <Typography variant="body1">
                            Should have enclosed eye protection within first aid
                            kit. Must be replaced after each use.
                        </Typography>
                    </Li>
                </ul>
            ),
        },
        cov_cov_ppe: {
            name: "PPE",
            icon: cov_cov_ppe,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">Face Mask</Typography>
                        <Typography variant="body1">
                            Face masks must be worn when working within 2m of
                            other people. They must also be worn when identified
                            by the risk assessment. If someone begins to feel
                            unwell they should also be worn subject to a risk
                            assessment. The face mask should only be handled by
                            the person who is wearing it.
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Neck Gaiter/Snood
                        </Typography>
                        <Typography variant="body1">
                            Snoods must be worn when working within 2m of other
                            people. They must also be worn when identified by
                            the risk assessment. If someone begins to feel
                            unwell they should also be worn subject to a risk
                            assessment. The snood should only be handled by the
                            person who is wearing it.
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            FFP3/ FFP2 Face Mask
                        </Typography>
                        <Typography variant="body1">
                            {"Should be worn if working <2m distancing."}
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Disposable Gloves
                        </Typography>
                        <Typography variant="body1">
                            Should NOT be selected as a primary infection
                            control. Hands MUST be cleaned straight after gloves
                            have been removed. Gloves MUST be disposed of after
                            each use and/or if they become damaged/torn. DO NOT
                            touch your face while wearing gloves.
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Disposable Overalls
                        </Typography>
                        <Typography variant="body1">
                            {
                                "May be provided if working <2m with another person for > 15 minutes."
                            }
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">Eye Protection</Typography>
                        <Typography variant="body1">
                            As oer HSE guidance, employees should be advised to
                            avoid touching face, particularly eyes, nose and
                            mouth, at all times.
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">Face Shields</Typography>
                        <Typography variant="body1">
                            {
                                "A full face visor may be selected if working <2m with another person  for >15 minutes."
                            }
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">Disposal</Typography>
                        <Typography variant="body1">
                            Are there adequate waste collection points for used
                            PPE.
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            No Home/ Cleaning
                        </Typography>
                        <Typography variant="body1">
                            Do Not take any COVID related PPE home. If re-using
                            PPE (NOT premitted for disposable PPE) there must be
                            an enhanced cleaning regime in place.
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">Radios</Typography>
                        <Typography variant="body1">
                            Ensure enhanced cleaning regieme for radios. Clean
                            before and after each use.
                        </Typography>
                    </Li>
                </ul>
            ),
        },
    },
};

export default json;
